export class OverAllScoreSetting {
  overallScoreSettingId?: number;
  name?: string;
  nameLatin?: string;
  code?: string;
  gradeScaleTypeId: number;
  displayOverallScore: boolean;
  forTeachersConsiderWithoutGradeEntry: boolean;
  forStudentsConsiderWithoutGradeEntry : boolean;
  calculateOverallEvenIfNotMandatoryEntered: boolean;
  gradeScaleId?: number;
  schoolId?:number;
  academicYearId: number;
  academicSemesterId: number;
  roundType?:number;
  decimalPlace?:number;
  overallScoreSettingSectionSubjects:number[];
  overallScoreSettingClasses?:number[];
  classes?: any[];
  IsGpaOverall:boolean;
}
